import React from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./calender.css";
import events from "./events"; // adapt your events format
import Navbar from "../../layout/navbar";

// Configure moment localizer
const localizer = momentLocalizer(moment);

const Calender = () => {
  return (
    <div className="flex">
      <Navbar />
      <div className="calenderSection">
        <h3 className="font-inter font-semibold text-2xl text-black mb-4">
          Events Calendar
        </h3>
        <Calendar
          localizer={localizer}
          events={events} // your events array
          startAccessor="start" // field name for event start date
          endAccessor="end" // field name for event end date
          defaultView={Views.MONTH}
          views={[Views.MONTH, Views.WEEK, Views.DAY]}
          style={{ height: 600 }}
          messages={{
            next: "Next",
            previous: "Prev",
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
          }}
          popup
        />
      </div>
    </div>
  );
};

export default Calender;
